<script lang="ts">
	import UnitManagementV2 from 'src/components/Settings/HomeManagement/UnitManagementV2.svelte';
	import SharedHomesToMeListV2 from 'src/components/Settings/HomeManagement/SharedHomesToMeListV2.svelte';
</script>

<UnitManagementV2 />
<SharedHomesToMeListV2 />
